import { render, staticRenderFns } from "./bg_extension.vue?vue&type=template&id=4232cf13&scoped=true"
import script from "./bg_extension.vue?vue&type=script&lang=js"
export * from "./bg_extension.vue?vue&type=script&lang=js"
import style0 from "./bg_extension.vue?vue&type=style&index=0&id=4232cf13&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4232cf13",
  null
  
)

export default component.exports